import {AxiosPromise} from 'axios';

import {backend} from '../../utils/_config/axios';

export default class PaypalService {
    public fetchMerchantIds(variantId: number): AxiosPromise<string[]> {
        return backend(true).get('/api/merchantIds/'+variantId);
    }
}